const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20a%20couple%20sharing%20an%20umbrella%20under%20gentle%20rain%20in%20a%20European%20cobblestone%20street%2C%20warm%20street%20lamp%20glow%2C%20soft%20cinematic%20lighting%2C%20vintage%20film%20aesthetic%2C%20intimate%20and%20tender%20mood&width=800&height=500&seq=card-movie-01&orientation=landscape',
    tag: '经典必看',
    title: '爱在黎明破晓前',
    desc: '火车上的偶遇，维也纳一夜的漫步长谈。这部被誉为最浪漫的爱情电影三部曲之首，是每对夫妻都不容错过的经典。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Couple%20sitting%20on%20a%20park%20bench%20under%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20pink%20petals%20falling%2C%20spring%20afternoon%20sunlight%2C%20romantic%20Japanese%20film%20aesthetic%2C%20gentle%20and%20dreamy%20atmosphere&width=800&height=500&seq=card-movie-02&orientation=landscape',
    tag: '日系纯爱',
    title: '花束般的恋爱',
    desc: '从相遇、相知到分离，一部关于爱情真实模样的动人故事。适合夫妻一起观看并重新审视彼此的感情。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Middle%20aged%20couple%20dancing%20slowly%20in%20their%20cozy%20living%20room%20filled%20with%20warm%20evening%20light%2C%20bookshelves%20and%20family%20photos%20in%20background%2C%20intimate%20domestic%20scene%2C%20tender%20realistic%20photography&width=800&height=500&seq=card-movie-03&orientation=landscape',
    tag: '夫妻必看',
    title: '婚姻故事',
    desc: '奥斯卡获奖影片，真实呈现婚姻中的爱与痛。看完之后，夫妻之间会有更多理解与包容。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Young%20couple%20having%20a%20picnic%20on%20a%20green%20hilltop%20overlooking%20a%20beautiful%20sunset%20valley%2C%20checkered%20blanket%2C%20wine%20bottle%2C%20golden%20hour%20warm%20lighting%2C%20cinematic%20wide%20angle%2C%20feel%20good%20romantic%20vibe&width=800&height=500&seq=card-movie-04&orientation=landscape',
    tag: '轻松浪漫',
    title: '时空恋旅人',
    desc: '一部关于爱、家庭和珍惜当下的温暖电影。幽默感人，是夫妻影院观众票选最受喜爱的英国爱情片。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elderly%20couple%20reading%20an%20old%20notebook%20together%20on%20a%20porch%20swing%20overlooking%20a%20lake%20at%20sunset%2C%20nostalgic%20warm%20atmosphere%2C%20soft%20golden%20light%2C%20emotional%20and%20touching%20scene%2C%20cinematic%20composition&width=800&height=500&seq=card-movie-05&orientation=landscape',
    tag: '催泪经典',
    title: '恋恋笔记本',
    desc: '陪伴是最长情的告白。这部横跨一生的爱情史诗，让无数夫妻在观影后更加珍惜身边的彼此。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Two%20young%20people%20planting%20a%20tree%20together%20in%20a%20sunlit%20meadow%2C%20both%20smiling%20and%20looking%20at%20each%20other%2C%20fresh%20and%20innocent%20atmosphere%2C%20coming%20of%20age%20romance%2C%20bright%20natural%20lighting%2C%20feel%20good%20American%20film%20aesthetic&width=800&height=500&seq=card-movie-06&orientation=landscape',
    tag: '青春回忆',
    title: '怦然心动',
    desc: '青梅竹马的美好故事，让你和爱人一起回忆最初心动的感觉。适合周末午后两个人窝在一起慢慢品味。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            编辑力荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            夫妻影院编辑团队为你精心挑选的浪漫电影推荐与夫妻必看影视
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`夫妻影院推荐 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block bg-primary-500 text-white text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}